import React from "react";
import "./UserInviteForm.scss";
import AuthContext from "../../../contexts/AuthContext";
import UserInviteModal from "../user-invite-modal/UserInviteModal";

export interface QrInviteFriendsCodeState {
  showModal: boolean;
  qrCodeCreatorKey: string;
}

export default class QrInviteFriendsCode extends React.PureComponent<{}, QrInviteFriendsCodeState> {
  static contextType = AuthContext;

  constructor(props: any) {
    super(props);
    this.state = {showModal: false, qrCodeCreatorKey: '' };
  }

  qrGenerate = () => {
    this.setState({
      qrCodeCreatorKey:
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/Register?reffererId=" +
        this.context.userInformation.personal.id,
    });
  };

  openQrInviteFriendsCodeModal = () => {
    this.setState({ showModal: true });
    this.qrGenerate();
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render(): React.ReactNode {
    let { qrCodeCreatorKey, showModal } = this.state;

    return (
      <>
        <UserInviteModal
          keyGenerator={qrCodeCreatorKey}
          showModal={showModal}
          closeModal={this.closeModal}
        />
      </>
    );
  }
}
